import {charcoal} from '../sass/base/_exports.sass';

export const WhatToBringLineIcon = (props) => {
  const {color = charcoal, className = '', ratio = 1} = props;

  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.4883 4.58398L24.7697 12H29.3337V14.6667H27.7777L26.7683 26.7773C26.7406 27.1105 26.5887 27.4211 26.3427 27.6476C26.0967 27.874 25.7747 27.9998 25.4403 28H6.56033C6.22599 27.9998 5.90392 27.874 5.65795 27.6476C5.41199 27.4211 5.26008 27.1105 5.23233 26.7773L4.22166 14.6667H2.66699V12H7.22966L11.5123 4.58398L13.8217 5.91732L10.3097 12H21.6897L18.179 5.91732L20.4883 4.58398ZM25.1017 14.6667H6.89766L7.78699 25.3333H24.2123L25.1017 14.6667ZM17.3337 17.3333V22.6667H14.667V17.3333H17.3337ZM12.0003 17.3333V22.6667H9.33366V17.3333H12.0003ZM22.667 17.3333V22.6667H20.0003V17.3333H22.667Z"
        fill={color}
      />
    </svg>
  );
};
